// useFetchListings.jsx


import { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';

const useFetchListings = (id = null) => {
  const [listings, setListings] = useState([]);
  const [singleListing, setSingleListing] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const database = getDatabase();
    if (id) {
      // Fetch a single listing by ID
      const listingRef = ref(database, `listings/${id}`);
      const unsubscribe = onValue(listingRef, (snapshot) => {
        setSingleListing(snapshot.val() || null);
        setLoading(false);
      });
      return () => unsubscribe();
    } else {
      // Fetch all listings
      const listingsRef = ref(database, 'listings');
      const unsubscribe = onValue(listingsRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const listingsArray = Object.keys(data).map((key) => {
            const listing = data[key];
            return {
              id: key,
              title: listing.title,
              price: listing.rent, // Use 'rent' as 'price'
              location: `${listing.city}, ${listing.state}`, // Combine city and state for location
              ...listing,
            };
          });
          setListings(listingsArray);
        } else {
          setListings([]);
        }
        setLoading(false);
      });
      return () => unsubscribe();
    }
  }, [id]);

  return id ? { singleListing, loading } : { listings, loading };
};

export default useFetchListings;

